export default __webpack_public_path__ + "static/media/beis.0aac2f50.svg";